module.exports = __webpack_public_path__ + "static/media/confirm_email.61d2dd34.png";